module.exports = __webpack_public_path__ + "assets/img/gal_12.09429948.jpg";